<template>
  <div v-show="!((applicationStatus==102||applicationStatus==1003) && !initData.limit) && (applicationStatus==102||applicationStatus==1003 || initData.id)">

    <z-collapse :title="$t('forfait.forfaitAgree')" :is-toggle="true" class="divider">

      <!--    如果放款审核中102 但是没有权限，整个福费廷都不显示-->
      <template v-slot:action>
        <p class="btn-blue" @click="printHandle">{{ $t('btns.print') }}</p>
      </template>
      <div class="forfait-msg mb_20">
        <ul v-if="(applicationStatus === 102||applicationStatus === 1003) && initData.limit" class="c-list forfait edit">
          <li><span class="tit">{{ $t('forfait.financingNum') }}</span>
            <div class="msg">
              <el-input v-model.trim="initData.flowNumber" disabled/>
            </div>
          </li>
          <!--      融资流水号-->
          <li><span class="tit">{{ $t('forfait.contractNum') }}</span>
            <div class="msg">
              <el-input v-model.trim="initData.contractNum" disabled/>
            </div>
          </li>
          <!--      合同号-->
          <li v-if="initData.invoiceNumber"><span class="tit">{{ $t('forfait.invoiceNum') }}</span>
            <div class="msg">
              <el-input v-model.trim="initData.invoiceNumber" disabled/>
            </div>
          </li>
          <li v-else><span class="tit">{{ $t('forfait.invoiceNum') }}</span>
            <div class="msg">
              <el-input v-model.trim="initData.invoiceNumberCoft" @input="invoiceNumberCoftInput" />
            </div>
          </li>

          <!--      发票号-->
          <li><span class="tit">{{ $t('forfait.seller') }}</span>
            <div class="msg">
              <el-input v-model.trim="initData.seller" disabled/>
            </div>
          </li>
          <!--      卖方-->
          <li><span class="tit">{{ $t('forfait.buyer') }}</span>
            <div class="msg">
              <el-input v-model.trim="initData.buyer" disabled/>
            </div>
          </li>
          <!--      买方-->
          <li><span class="tit">{{ $t('forfait.paymentCurrency') }}</span>
            <div class="msg">
              <el-select v-model="currency" class="w-240" @change="currencyChange()">
                <el-option v-for="(key,value) in currencyList" :label="value" :value="key" :key="key"/>
              </el-select>
            </div>
          </li>
          <!--      币种-->
          <li><span class="tit">{{ $t('forfait.exchangeRate') }}</span>
            <div class="msg">
              <el-input
                v-model.trim="exchangeRate"
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                clearable
                @keyup.native="exchangeRateInput"
                @blur="numberBlur('exchangeRate',4)"/>
            </div>
          </li>
          <!--      汇率-->

          <li><span class="tit">{{ !initData.loanType? $t('forfait.sellerInvoiceFund'):$t('newrisk.estimated_invoice_amount') }}</span>
            <div class="msg cols">
              <div class="w-240">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="sellerAmount"
                  :maxlength="17"
                  clearable
                  @blur="numberBlur('sellerAmount',2)"
                  @keyup.native="sellerAmountInput">
                  <template slot="prepend">{{ currency }}</template>
                </el-input>
              </div>
              <div class="w-300">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="exchangeSellerAmount"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('exchangeSellerAmount',2)"
                  @keyup.native="moneyInput('exchangeSellerAmount')">
                  <template slot="prepend">{{ defaultCurrency }}</template>
                </el-input>
              </div> <!-- add USD 汇率计算金额 -->
              <div class="w-180">
                <el-input :placeholder="$t('financingAppliForm.pleaseEnText')" value="100%" disabled/>
              </div>
            </div>
          </li>
          <!--      卖方发票金额-->

          <li><span class="tit">{{ $t('forfait.deposit') }}</span>
            <div class="msg cols">
              <div class="w-240">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="receivedPayment"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('receivedPayment',2)"
                  @keyup.native="receivedPaymentInput">
                  <template slot="prepend">{{ currency }}</template>
                </el-input>
              </div>
              <div class="w-300">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="exchangeReceivedPayment"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('exchangeReceivedPayment',2)"
                  @keyup.native="moneyInput('exchangeReceivedPayment')">
                  <template slot="prepend">{{ defaultCurrency }}</template>
                </el-input>
              </div> <!-- add USD 汇率计算金额 -->
              <div class="w-180">
                <el-input
                  v-model.trim="receivedPaymentProportion"
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  maxlength="17"
                  @blur="numberBlur('receivedPaymentProportion',3)"
                  @keyup.native="rateInput('receivedPaymentProportion')">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </div>
          </li>
          <!--      定金-->

          <li><span class="tit">{{ $t('forfait.cicFee') }}</span>
            <div class="msg cols">
              <div class="w-240">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="cicAmount"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('cicAmount',2)"
                  @keyup.native="cicAmountInput">
                  <template slot="prepend">{{ currency }}</template>
                </el-input>
              </div>
              <div class="w-300">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="exchangeCicAmount"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('exchangeCicAmount',2)"
                  @keyup.native="moneyInput('exchangeCicAmount')">
                  <template slot="prepend">{{ defaultCurrency }}</template>
                </el-input>
              </div> <!-- add USD 汇率计算金额 -->
              <div class="w-180">
                <el-input
                  v-model.trim="cicAmountProportion"
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  maxlength="17"
                  @blur="numberBlur('cicAmountProportion',3)"
                  @keyup.native="rateInput('cicAmountProportion')">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </div>
          </li>
          <!--      CIC费用-->

          <li><span class="tit">{{ $t('forfait.refundAmount') }}</span>
            <div class="msg cols">
              <div class="w-240">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="receivableAmount"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('receivableAmount',2)"
                  @keyup.native="receivableAmountInput">
                  <template slot="prepend">{{ currency }}</template>
                </el-input>
              </div>
              <div class="w-300">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="exchangeReceivableAmount"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('exchangeReceivableAmount',2)"
                  @keyup.native="moneyInput('exchangeReceivableAmount')">
                  <template slot="prepend">{{ defaultCurrency }}</template>
                </el-input>
              </div> <!-- add USD 汇率计算金额 -->
              <div class="w-180">
                <el-input
                  v-model.trim="receivableAmountProportion"
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  maxlength="17"
                  @blur="numberBlur('receivableAmountProportion',3)"
                  @keyup.native="rateInput('receivableAmountProportion')">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </div>
          </li>
          <!--      还款金额-->

          <li><span class="tit">{{ $t('forfait.loanAmount') }}</span>
            <div class="msg cols">
              <div class="w-240">
                <el-input
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  v-model.trim="cicLoan"
                  class="firstEdit"
                  clearable
                  maxlength="17"
                  @blur="numberBlur('cicLoan',2)"
                  @keyup.native="cicLoanInput">
                  <template slot="prepend">{{ defaultCurrency }}</template>
                </el-input>
              </div>
              <div class="w-300">
                <span class="sub-tit">ZALL</span>
                <div class="sub-msg">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="cicLoanZall"
                    clearable
                    maxlength="17"
                    @blur="numberBlur('cicLoanZall',2)"
                    @keyup.native="moneyInput('cicLoanZall')">
                    <template slot="prepend">{{ defaultCurrency }}</template>
                  </el-input>
                </div>
              </div>
              <div class="w-180">
                <el-input :placeholder="$t('financingAppliForm.pleaseEnText')" value="51%" disabled/>
              </div>
            </div>
          </li>
          <li><span class="tit"/>
            <div class="msg cols">
              <div class="w-240"/>
              <div class="w-300">
                <span class="sub-tit">Mizuho</span>
                <div class="sub-msg">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="cicLoanMizhuho"
                    clearable
                    maxlength="17"
                    @blur="numberBlur('cicLoanMizhuho',2)"
                    @keyup.native="moneyInput('cicLoanMizhuho')">
                    <template slot="prepend">{{ defaultCurrency }}</template>
                  </el-input>
                </div>
              </div>
              <div class="w-180">
                <el-input :placeholder="$t('financingAppliForm.pleaseEnText')" value="49%" disabled/>
              </div>
            </div>
          </li>
          <!--    贷款金额-->

          <li><span class="tit">{{ $t('forfait.interestAmount') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="feeAmount"
                clearable
                maxlength="17"
                @blur="numberBlur('feeAmount',2)"
                @keyup.native="feeAmountInput">
                <template slot="prepend">{{ defaultCurrency }}</template>
              </el-input>
            </div>
          </li>
          <!--    利息金额-->

          <li><span class="tit">{{ $t('forfait.loanDate') }}</span>
            <div class="msg">
              <el-date-picker
                v-model="transactionDateStr"
                :placeholder="$t('loan.selectTime')"
                class="firstEdit"
                type="date"
                @change="transactionDateStrChange"/>
            </div>
          </li>
          <!--    贷款发放日期-->
          <li><span class="tit">{{ $t('forfait.dueDate') }}</span>
            <div class="msg">
              <el-date-picker
                v-model="maturityDateStr"
                :placeholder="$t('loan.selectTime')"
                class="firstEdit"
                type="date"
                @change="maturityDateStrChange"/>
            </div>
          </li>
          <!--    还款日-->
          <li><span class="tit">{{ $t('forfait.paymentDays') }}</span>
            <div class="msg">
              <el-input v-model.trim="paymentDays" maxlength="50" clearable disabled>
                <template slot="append">{{ $t('loan.day') }}</template>
              </el-input>
            </div>
          </li>
          <!--    账期-->

          <li><span class="tit">{{ $t('forfait.interestRate') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="rateDiscount"
                clearable
                maxlength="17"
                @keyup.native="rateDiscountInput()">
                <template slot="append">%</template>
              </el-input>
            </div>
          </li>
          <!--      利率-->

          <li><span class="tit">{{ $t('loan.receivedBankName') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model="initData.collectionBank"
                maxlength="50"
                clearable/>
            </div>
          </li>
          <!--    收款银行名称-->
          <li><span class="tit">{{ $t('loan.receivedBankCode') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model="initData.collectionBankSwifucode"
                maxlength="50"
                clearable/>
            </div>
          </li>
          <!--    收款银行swiftcode-->
          <li><span class="tit">{{ $t('loan.middleBankName') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model="initData.middleBank"
                maxlength="50"
                clearable/>
            </div>
          </li>
          <!--    中间行名称-->
          <li><span class="tit">{{ $t('loan.middleBankCode') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model="initData.middleSwifucode"
                maxlength="50"
                clearable/>
            </div>
          </li>
          <!--    中间行swiftcode-->
          <li><span class="tit">{{ $t('loan.account') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model="initData.accountNumber"
                maxlength="50"
                clearable/>
            </div>
          </li>
          <!--    账号-->
          <template v-if="!initData.finalLoan">
            <li><span class="tit">{{ $t('forfait.estimateStartDate') }}</span>
              <div class="msg">
                <el-date-picker
                  v-model="estimateStartDateStr"
                  :placeholder="$t('loan.selectTime')"
                  type="date"/>
              </div>
            </li>
            <!--    资金出入预计开始时间-->
            <li><span class="tit">{{ $t('forfait.estimateEndDate') }}</span>
              <div class="msg">
                <el-date-picker
                  v-model="estimateEndDateStr"
                  :placeholder="$t('loan.selectTime')"
                  type="date"/>
              </div>
            </li>
            <!--    资金出入预计到期时间-->
            <li><span class="tit">{{ $t('loan.numberOfDay') }}</span>
              <div class="msg line36">
                <el-input v-model.trim="estimateDay" maxlength="50" clearable disabled>
                  <template slot="append">{{ $t('loan.day') }}</template>
                </el-input>
              </div>
            </li>
            <!--    天数-->
          </template>

          <li><span class="tit">{{ $t('loan.remark') }}</span>
            <div class="msg">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model="initData.remarks"
                maxlength="200"
                clearable/>
            </div>
          </li>
          <!--    备注-->
        </ul>
        <!--      福费廷协议 第一部分 表单-->

        <ul v-if="(applicationStatus > 102&& !initData.loanType)||(applicationStatus > 1003&&initData.loanType)" class="c-list forfait">

          <li><span class="tit">{{ $t('forfait.financingNum') }}</span>
            <div class="msg">{{ initData.flowNumber }}</div>
          </li>
          <!--      融资流水号-->
          <li><span class="tit">{{ $t('forfait.contractNum') }}</span>
            <div class="msg">{{ initData.contractNum }}</div>
          </li>
          <!--      合同号-->
          <li><span class="tit">{{ $t('forfait.invoiceNum') }}</span>
            <div class="msg">{{ initData.invoiceNumber||initData.invoiceNumberCoft }}</div>
          </li>
          <!--      发票号-->
          <li><span class="tit">{{ $t('forfait.seller') }}</span>
            <div class="msg">{{ initData.seller }}</div>
          </li>
          <!--      卖方-->
          <li><span class="tit">{{ $t('forfait.buyer') }}</span>
            <div class="msg">{{ initData.buyer }}</div>
          </li>
          <!--      买方-->
          <li><span class="tit">{{ $t('forfait.paymentCurrency') }}</span>
            <div class="msg">{{ currency }}</div>
          </li>
          <!--      币种-->
          <li><span class="tit">{{ $t('forfait.exchangeRate') }}</span>
            <div class="msg">{{ exchangeRate }}</div>
          </li>
          <!--      汇率-->
          <li><span class="tit">{{ !initData.loanType?$t('forfait.sellerInvoiceFund'):$t('newrisk.estimated_invoice_amount') }}</span>
            <div class="msg cols">
              <div class="w-240">{{ currency }} {{ sellerAmount | formatNum(2) }}</div>
              <div class="w-300">{{ defaultCurrency }} {{ exchangeSellerAmount| formatNum(2) }}</div>
              <div class="w-180">100%</div>
            </div>
          </li>
          <!--      卖方发票金额-->

          <li><span class="tit">{{ $t('forfait.deposit') }}</span>
            <div class="msg cols">
              <div class="w-240">{{ currency }} {{ receivedPayment | formatNum(2) }}</div>
              <div class="w-300">{{ defaultCurrency }} {{ exchangeReceivedPayment | formatNum(2) }}</div>
              <div class="w-180">{{ receivedPaymentProportion | formatNum(3) }}%</div>
            </div>
          </li>
          <!--      定金-->

          <li><span class="tit">{{ $t('forfait.cicFee') }}</span>
            <div class="msg cols">
              <div class="w-240">{{ currency }} {{ cicAmount | formatNum(2) }}</div>
              <div class="w-300">{{ defaultCurrency }} {{ exchangeCicAmount | formatNum(2) }}</div>
              <div class="w-180">{{ cicAmountProportion | formatNum(3) }}%</div>
            </div>
          </li>
          <!--      CIC费用-->

          <li><span class="tit">{{ $t('forfait.refundAmount') }}</span>
            <div class="msg cols">
              <div class="w-240">{{ currency }} {{ receivableAmount | formatNum(2) }}</div>
              <div class="w-300">{{ defaultCurrency }} {{ exchangeReceivableAmount | formatNum(2) }}</div>
              <div class="w-180">{{ receivableAmountProportion | formatNum(3) }}%</div>
            </div>
          </li>
          <!--      还款金额-->

          <li><span class="tit">{{ $t('forfait.loanAmount') }}</span>
            <div class="msg cols">
              <div class="w-240">{{ defaultCurrency }} {{ cicLoan | formatNum(2) }}</div>
              <div class="w-300">
                <span class="sub-tit">ZALL</span>
                <span class="sub-msg">{{ defaultCurrency }} {{ cicLoanZall | formatNum(2) }}</span>
              </div>
              <div class="w-180">51%</div>
            </div>
          </li>
          <li><span class="tit"/>
            <div class="msg cols">
              <div class="w-240"/>
              <div class="w-300">
                <span class="sub-tit">Mizuho</span>
                <span class="sub-msg">{{ defaultCurrency }} {{ cicLoanMizhuho | formatNum(2) }}</span>
              </div>
              <div class="w-180">49%</div>
            </div>
          </li>
          <!--    贷款金额-->

          <li><span class="tit">{{ $t('forfait.interestAmount') }}</span>
            <div class="msg">{{ defaultCurrency }} {{ feeAmount | formatNum(2) }}</div>
          </li>
          <!--    利息金额-->
          <li><span class="tit">{{ $t('forfait.loanDate') }}</span>
            <div class="msg">{{ transactionDateStr | dateConvert }}</div>
          </li>
          <!--    贷款发放日期-->
          <li><span class="tit">{{ $t('forfait.dueDate') }}</span>
            <div class="msg">{{ maturityDateStr | dateConvert }}</div>
          </li>
          <!--    还款日-->
          <li><span class="tit">{{ $t('forfait.paymentDays') }}</span>
            <div class="msg">{{ paymentDays }} {{ $t('loan.day') }}</div>
          </li>
          <!--    账期-->

          <li><span class="tit">{{ $t('forfait.interestRate') }}</span>
            <div class="msg">{{ rateDiscount | formatNum(3) }}%</div>
          </li>
          <!--      利率-->

          <li><span class="tit">{{ $t('loan.receivedBankName') }}</span>
            <div class="msg">{{ initData.collectionBank }}</div>
          </li>
          <!--    收款银行名称-->
          <li><span class="tit">{{ $t('loan.receivedBankCode') }}</span>
            <div class="msg">{{ initData.collectionBankSwifucode }}</div>
          </li>
          <!--    收款银行swiftcode-->
          <li><span class="tit">{{ $t('loan.middleBankName') }}</span>
            <div class="msg">{{ initData.middleBank }}</div>
          </li>
          <!--    中间行名称-->
          <li><span class="tit">{{ $t('loan.middleBankCode') }}</span>
            <div class="msg">{{ initData.middleSwifucode }}</div>
          </li>
          <!--    中间行swiftcode-->
          <li><span class="tit">{{ $t('loan.account') }}</span>
            <div class="msg">{{ initData.accountNumber }}</div>
          </li>
          <!--    账号-->
          <li><span class="tit">{{ $t('loan.remark') }}</span>
            <div class="msg">{{ initData.remarks }}</div>
          </li>
          <!--    备注-->
        </ul>
        <!--      福费廷协议 第一部分 详情-->

        <div v-if="(applicationStatus >= 108&& !initData.loanType)||(applicationStatus >= 1006&& initData.loanType)" class="loan-msg">
          <ul v-if="(applicationStatus === 108||applicationStatus === 1006) && initData.limit" class="c-list forfait edit">

            <li><span class="tit">{{ $t('forfait.zmaFundRate') }}</span>
              <div class="msg">
                <el-input
                  v-model.trim="zmaFundingRate"
                  :placeholder="$t('financingAppliForm.pleaseEnText')"
                  maxlength="50"
                  @blur="numberBlur('zmaFundingRate',4)"
                  @keyup.native="zmaFundingRateInput">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </li>
            <!--       zma 成本-->

            <li><span class="tit">{{ $t('forfait.zallLendRate') }}</span>
              <div class="msg cols">
                <div class="w-180">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="zallLendingRate"
                    :maxlength="17"
                    clearable
                    @blur="numberBlur('zallLendingRate',4)"
                    @keyup.native="zallLendingRateInput">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div>
                  <span class="sub-tit" style="width: 100px;">Fee Amount</span>
                  <div class="sub-msg" style="width: 180px;">
                    <el-input
                      :placeholder="$t('financingAppliForm.pleaseEnText')"
                      v-model.trim="zallLendingMoney"
                      :maxlength="17"
                      clearable
                      @blur="numberBlur('zallLendingMoney',2)"
                      @keyup.native="zallLendingMoneyInput">
                      <template slot="prepend">{{ defaultCurrency }}</template>
                    </el-input>
                  </div>
                </div>
                <div>
                  <span class="sub-tit" style="width: 110px;">Amount Payable</span>
                  <div class="sub-msg" style="width: 180px;">
                    <el-input
                      :placeholder="$t('financingAppliForm.pleaseEnText')"
                      v-model.trim="zallLendingFinal"
                      clearable
                      maxlength="17"
                      @blur="numberBlur('zallLendingFinal',2)"
                      @keyup.native="moneyInput('zallLendingFinal')">
                      <template slot="prepend">{{ defaultCurrency }}</template>
                    </el-input>
                  </div>
                </div>
              </div>
            </li>
            <!--      卓尔利率-->

            <li><span class="tit">{{ $t('forfait.mizuhoLendRate') }}</span>
              <div class="msg cols">
                <div class="w-180">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="mizhuhoLendingRate"
                    :maxlength="17"
                    class="firstEdit"
                    clearable
                    @blur="numberBlur('mizhuhoLendingRate',4)"
                    @keyup.native="mizhuhoLendingRateInput">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div>
                  <span class="sub-tit" style="width: 100px;">Fee Amount</span>
                  <div class="sub-msg" style="width: 180px;">
                    <el-input
                      :placeholder="$t('financingAppliForm.pleaseEnText')"
                      v-model.trim="mizhuhoLendingMoney"
                      :maxlength="17"
                      clearable
                      @blur="numberBlur('mizhuhoLendingMoney',2)"
                      @keyup.native="mizhuhoLendingMoneyInput">
                      <template slot="prepend">{{ defaultCurrency }}</template>
                    </el-input>
                  </div>
                </div>
                <div>
                  <span class="sub-tit" style="width: 110px;">Amount Payable</span>
                  <div class="sub-msg" style="width: 180px;">
                    <el-input
                      :placeholder="$t('financingAppliForm.pleaseEnText')"
                      v-model.trim="mizhuhoLendingFinal"
                      clearable
                      maxlength="17"
                      @blur="numberBlur('mizhuhoLendingFinal',2)"
                      @keyup.native="moneyInput('mizhuhoLendingFinal')">
                      <template slot="prepend">{{ defaultCurrency }}</template>
                    </el-input>
                  </div>
                </div>
              </div>
            </li>
            <!--      Mizuho利率-->

            <li><span class="tit">{{ $t('forfait.marubeniFee') }}</span>
              <div class="msg cols">
                <div class="w-180">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="marubeniFeeRate"
                    :maxlength="17"
                    class="firstEdit"
                    clearable
                    @blur="numberBlur('marubeniFeeRate',4)"
                    @keyup.native="marubeniFeeRateInput">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div>
                  <span class="sub-tit" style="width: 100px;">Fee Amount</span>
                  <div class="sub-msg" style="width: 180px;">
                    <el-input
                      :placeholder="$t('financingAppliForm.pleaseEnText')"
                      v-model.trim="marubeniFeeMoney"
                      :maxlength="17"
                      clearable
                      @blur="numberBlur('marubeniFeeMoney',2)"
                      @keyup.native="moneyInput('marubeniFeeMoney')">
                      <template slot="prepend">{{ defaultCurrency }}</template>
                    </el-input>
                  </div>
                </div>
                <div style="width: 290px;"/>
              </div>
            </li>
            <!--     丸红担保费-->

            <li><span class="tit">{{ $t('forfait.zmaInterestMargin') }}</span>
              <div class="msg cols">
                <div class="w-180">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="zmaMarginRate"
                    :maxlength="17"
                    clearable
                    @blur="numberBlur('zmaMarginRate',4)"
                    @keyup.native="rateInput('zmaMarginRate')">
                    <template slot="append">%</template>
                  </el-input>
                </div>
              </div>
            </li>
            <!--     ZMA利润利率-->

            <li><span class="tit">{{ $t('forfait.zmaInterestProfit') }}</span>
              <div class="msg cols">
                <div class="w-180">
                  <el-input
                    :placeholder="$t('financingAppliForm.pleaseEnText')"
                    v-model.trim="zmaProfit"
                    :maxlength="17"
                    clearable
                    @blur="numberBlur('zmaProfit',2)"
                    @keyup.native="moneyInput('zmaProfit')">
                    <template slot="prepend">{{ defaultCurrency }}</template>
                  </el-input>
                </div>
              </div>
            </li>
            <!--     ZMA利润-->

          </ul>
          <!--      福费廷协议 第二部分 表单-->

          <ul v-if="(applicationStatus > 108&& !initData.loanType)||(applicationStatus > 1006&& initData.loanType)" class="c-list forfait">
            <li><span class="tit">{{ $t('forfait.zmaFundRate') }}</span>
              <div class="msg">{{ initData.zmaFundingRate | formatNum(4) }}%</div>
            </li>
            <!--      zma 成本-->

            <li><span class="tit">{{ $t('forfait.zallLendRate') }}</span>
              <div class="msg cols">
                <div class="w-180">{{ initData.zallLendingRate | formatNum(4) }}%</div>
                <div class="w-300"><span style="width: 100px">Fee Amount </span>{{ defaultCurrency }} {{ initData.zallLendingMoney | formatNum(2) }}</div>
                <div class="w-300">Amount Payable {{ defaultCurrency }} {{ initData.zallLendingFinal | formatNum(2) }}
                  <!--              <span>Amount Payable {{defaultCurrency}} </span>-->
                  <!--              <div class="sub-msg" style="width: 180px;">{{initData.zallLendingFinal | formatNum(2)}}</div>-->
                </div>
              </div>
            </li>
            <!--      卓尔利率-->

            <li><span class="tit">{{ $t('forfait.mizuhoLendRate') }}</span>
              <div class="msg cols">
                <div class="w-180">{{ initData.mizhuhoLendingRate | formatNum(4) }}%</div>
                <div class="w-300"><span style="width: 100px">Fee Amount </span>{{ defaultCurrency }} {{ initData.mizhuhoLendingMoney | formatNum(2) }}</div>
                <div class="w-300">Amount Payable {{ defaultCurrency }} {{ initData.mizhuhoLendingFinal | formatNum(2) }}
                </div>
              </div>
            </li>
            <!--      Mizuho利率-->

            <li><span class="tit">{{ $t('forfait.marubeniFee') }}</span>
              <div class="msg cols">
                <div class="w-180">{{ initData.marubeniFeeRate | formatNum(4) }}%</div>
                <div class="w-300"><span style="width: 100px">Fee Amount </span>{{ defaultCurrency }} {{ initData.marubeniFeeMoney | formatNum(2) }}</div>
                <div class="w-300"/>
              </div>
            </li>
            <!--      丸红担保费-->

            <li><span class="tit">{{ $t('forfait.zmaInterestMargin') }}</span>
              <div class="msg">{{ initData.zmaMarginRate | formatNum(4) }}%</div>
            </li>
            <!--      ZMA利润利率-->

            <li><span class="tit">{{ $t('forfait.zmaInterestProfit') }}</span>
              <div class="msg">{{ defaultCurrency }} {{ initData.zmaProfit | formatNum(2) }}</div>
            </li>
            <!--      ZMA利润-->
          </ul>
          <!--      福费廷协议 第二部分 详情-->
        </div>
        <!--      福费廷协议 第二部分-->

        <ul v-if="initData.zmaCoftFileList && initData.zmaCoftFileList.length > 0 &&applicationStatus!=1008&&applicationStatus!=112" class="c-list border forfait">
          <li>
            <span class="tit">{{ $t('loan.fileUpload') }}</span>
            <div class="msg c-file-list"><a v-for="(fileObj,fileIndex) in initData.zmaCoftFileList" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)"><i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}</a></div>
          </li>
        </ul>
        <!--        福费廷文件 -->
      </div>

      <el-dialog :visible.sync="printVisible" width="100%" custom-class="dialogPrint">
        <div ref="printContract" class="print-msg line">
          <div class="header" style="padding: 50px 0 20px;">
            <img src="@/assets/images/zma.png" alt="">
          </div>
          <div class="m-tit">
            <h3>Confirmation of Factoring Transaction</h3>
          </div>
          <ul class="c-list">
            <li><span class="tit">{{ $t('invoice.serialNumber') }}</span>
              <div class="msg">{{ initData.flowNumber }}</div>
            </li>
            <!--      融资流水号-->
            <li><span class="tit">{{ $t('invoice.contractNum') }}</span>
              <div class="msg">{{ initData.contractNum }}</div>
            </li>
            <!--      合同号-->
            <li><span class="tit">{{ $t('invoice.invoiceNum') }}</span>
              <div class="msg">{{ initData.invoiceNumber|| initData.invoiceNumberCoft }}</div>
            </li>
            <!--      发票号-->
            <li><span class="tit">{{ $t('invoice.seller') }}</span>
              <div class="msg">{{ initData.seller }}</div>
            </li>
            <!--      卖方-->
            <li><span class="tit">{{ $t('invoice.buyer') }}</span>
              <div class="msg">{{ initData.buyer }}</div>
            </li>
            <!--      买方-->
            <li><span class="tit">{{ $t('invoice.currency') }}</span>
              <div class="msg">{{ currency }}</div>
            </li>
            <!--      币种-->
            <li><span class="tit">{{ $t('invoice.exchangeRate') }}</span>
              <div class="msg">{{ exchangeRate }}</div>
            </li>
            <!--      汇率-->
            <li><span class="tit">{{ $t('invoice.contractAmount') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ currency }}</span>
                <span class="span-2">{{ sellerAmount | formatNum(2) }}</span>
                <span class="span-1">{{ defaultCurrency }}</span>
                <span class="span-2">{{ (sellerAmount * exchangeRate).toFixed(2)| formatNum(2) }}</span>
                <span class="span-3">100%</span>
                <!--            <div class="left">{{currency}} {{sellerAmount | formatNum(2)}}</div>-->
                <!--            <div class="center">{{defaultCurrency}} {{ (sellerAmount * exchangeRate).toFixed(2)| formatNum(2)}}</div>-->
                <!--            <div class="right">100%</div>-->
              </div>
            </li>
            <!--      卖方发票金额-->
            <li><span class="tit">{{ $t('invoice.receivedDown') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ currency }}</span>
                <span class="span-2">{{ receivedPayment | formatNum(2) }}</span>
                <span class="span-1">{{ defaultCurrency }}</span>
                <span class="span-2">{{ (receivedPayment * exchangeRate).toFixed(2)| formatNum(2) }}</span>
                <span class="span-3">{{ receivedPaymentProportion | formatNum(3) }}%</span>
                <!--            <div class="left">{{currency}} {{receivedPayment | formatNum(2)}}</div>-->
                <!--            <div class="center">{{defaultCurrency}} {{ (receivedPayment * exchangeRate).toFixed(2)| formatNum(2)}}</div>-->
                <!--            <div class="right">{{receivedPaymentProportion | formatNum(3)}}%</div>-->
              </div>
            </li>
            <!--      定金-->

            <li><span class="tit">{{ $t('invoice.collectionExpenses') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ currency }}</span>
                <span class="span-2">{{ cicAmount | formatNum(2) }}</span>
                <span class="span-1">{{ defaultCurrency }}</span>
                <span class="span-2">{{ (cicAmount * exchangeRate).toFixed(2) | formatNum(2) }}</span>
                <span class="span-3">{{ cicAmountProportion | formatNum(3) }}%</span>
                <!--            <div class="left">{{currency}} {{cicAmount | formatNum(2)}}</div>-->
                <!--            <div class="center">{{defaultCurrency}} {{ (cicAmount * exchangeRate).toFixed(2) | formatNum(2)}}</div>-->
                <!--            <div class="right">{{cicAmountProportion | formatNum(3)}}%</div>-->
              </div>
            </li>
            <!--      CIC费用-->

            <li><span class="tit">{{ $t('invoice.zmaAmount') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ currency }}</span>
                <span class="span-2">{{ receivableAmount | formatNum(2) }}</span>
                <span class="span-1">{{ defaultCurrency }}</span>
                <span class="span-2">{{ (receivableAmount * exchangeRate).toFixed(2) | formatNum(2) }}</span>
                <span class="span-3">{{ receivableAmountProportion | formatNum(3) }}%</span>
                <!--            <div class="left">{{currency}} {{receivableAmount | formatNum(2)}}</div>-->
                <!--            <div class="center">{{defaultCurrency}} {{ (receivableAmount * exchangeRate).toFixed(2) | formatNum(2)}}</div>-->
                <!--            <div class="right">{{receivableAmountProportion | formatNum(3)}}%</div>-->
              </div>
            </li>
            <!--      还款金额-->

            <li><span class="tit">{{ $t('invoice.paymentToCic') }}</span>
              <div class="msg" style="padding: 0;">
                <p class="cols2">
                  <span class="span-1">{{ defaultCurrency }}</span>
                  <span class="span-2">{{ cicLoan | formatNum(2) }}</span>
                  <span class="span-1">ZALL {{ defaultCurrency }}</span>
                  <span class="span-2">{{ cicLoanZall | formatNum(2) }}</span>
                  <span class="span-3">51%</span>
                </p>
                <p class="cols2">
                  <span class="span-1"/>
                  <span class="span-2"/>
                  <span class="span-1 b-t">Mizuho {{ defaultCurrency }}</span>
                  <span class="span-2 b-t">{{ cicLoanMizhuho | formatNum(2) }}</span>
                  <span class="span-3 b-t">49%</span>
                </p>
              </div>
            </li>

            <li><span class="tit">{{ $t('invoice.zmaTransactionFee') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ defaultCurrency }}</span>
                <span class="span-0">{{ feeAmount | formatNum(2) }}</span>
              </div>
            </li>
            <!--    利息金额-->
            <li><span class="tit">{{ $t('invoice.transactionDate') }}</span>
              <div class="msg">{{ transactionDateStr | dateConvert }}</div>
            </li>
            <!--    贷款发放日期-->
            <li><span class="tit">{{ $t('invoice.maturityDate') }}</span>
              <div class="msg">{{ maturityDateStr | dateConvert }}</div>
            </li>
            <!--    还款日-->
            <li><span class="tit">{{ $t('invoice.period') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ paymentDays }}</span>
                <span class="span-0">Days</span>
              </div>
            </li>
            <!--    账期-->
            <li><span class="tit">{{ $t('invoice.zmaDiscountRate') }}</span>
              <div class="msg">{{ rateDiscount | formatNum(3) }}%</div>
            </li>
            <!--      利率-->
            <li><span class="tit">{{ $t('invoice.zmaFundingRate') }}</span>
              <div class="msg">{{ zmaFundingRate | formatNum(4) }}%</div>
            </li>
            <!--    ZMA成本-->

            <li><span class="tit">{{ $t('invoice.zmaLendingRate') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ zallLendingRate | formatNum(4) }}%</span>
                <span class="span-2 t-r">{{ $t('invoice.feeAmount') }} {{ defaultCurrency }}</span>
                <span class="span-1 t-l">{{ zallLendingMoney | formatNum(2) }}</span>
                <span class="span-2 t-r">Amount Payable {{ defaultCurrency }}</span>
                <span class="span-3">{{ zallLendingFinal | formatNum(2) }}</span>
                <!--            <div class="left">{{initData.zallLendingRate | formatNum(3)}}%</div>-->
                <!--            <div class="center">{{$t('invoice.feeAmount')}} {{defaultCurrency}} {{initData.zallLendingMoney | formatNum(2)}}</div>-->
              </div>
            </li>
            <!--    卓尔利率-->
            <li><span class="tit">{{ $t('invoice.mizuhoLendingRate') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ mizhuhoLendingRate | formatNum(4) }}%</span>
                <span class="span-2 t-r">{{ $t('invoice.feeAmount') }} {{ defaultCurrency }}</span>
                <span class="span-1 t-l">{{ mizhuhoLendingMoney | formatNum(2) }}</span>
                <span class="span-2 t-r">Amount Payable {{ defaultCurrency }}</span>
                <span class="span-3">{{ mizhuhoLendingFinal | formatNum(2) }}</span>
                <!--            <div class="left">{{initData.mizhuhoLendingRate | formatNum(3)}}%</div>-->
                <!--            <div class="center">{{$t('invoice.feeAmount')}} {{defaultCurrency}} {{initData.mizhuhoLendingMoney | formatNum(2)}}</div>-->
              </div>
            </li>
            <!--    Mizuho利率-->
            <li><span class="tit">{{ $t('invoice.guaranteeFee') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ marubeniFeeRate | formatNum(4) }}%</span>
                <span class="span-2 t-r">{{ $t('invoice.feeAmount') }} {{ defaultCurrency }}</span>
                <span class="span-1 t-l">{{ marubeniFeeMoney | formatNum(2) }}</span>
                <span class="span-2 t-r"/>
                <span class="span-3"/>
                <!--            <div class="left">{{initData.marubeniFeeRate | formatNum(3)}}%</div>-->
                <!--            <div class="center">{{$t('invoice.feeAmount')}} {{defaultCurrency}} {{initData.marubeniFeeMoney | formatNum(2)}}</div>-->
              </div>
            </li>
            <!--    丸红担保费-->
            <li><span class="tit">{{ $t('invoice.zmaInterestMargin') }}</span>
              <div class="msg">{{ zmaMarginRate | formatNum(4) }}%</div>
            </li>
            <!--      ZMA利率利润-->
            <li><span class="tit">{{ $t('invoice.zmaInterestProfit') }}</span>
              <div class="msg cols2">
                <span class="span-1">{{ defaultCurrency }}</span>
                <span class="span-0">{{ zmaProfit | formatNum(2) }}</span>
                <!--            {{defaultCurrency}} {{initData.zmaProfit | formatNum(2)}}-->
              </div>
            </li>
            <!--      ZMA利润-->
          </ul>
          <ul class="c-list remark">
            <li><span class="tit">{{ $t('invoice.remarks') }}</span>
              <div class="msg" v-html="initData.remarks"/>
            </li>
          </ul>

          <div class="c-box">
            <h3 class="c-tit">{{ $t('invoice.confirmedBy') }}</h3>
            <ul class="sign-list clearfix">
              <li class="fl">
                <p :class="initData.leftName && initData.leftName.indexOf('Name:')>-1?'tLeft':''" class="p1">{{ initData.leftName }}</p>
                <p class="p2"/>
                <p class="p3"/>
              </li>
              <li class="fr">
                <p :class="initData.rightName && initData.rightName.indexOf('Name:')>-1?'tLeft':''" class="p1">{{ initData.rightName }}</p>
                <p class="p2"/>
                <p class="p3"/>
              </li>
            </ul>
          </div>
        </div>

        <div slot="footer" class="print-footer text-center">
          <div class="centerBtn btn-border-normal" @click="printVisible = false">{{ $t('btns.closePreview') }}</div>
          <div class="centerBtn btn-blue" @click="dialogConfirm">{{ $t('btns.print') }}</div>
        </div>
      </el-dialog>
      <!--      打印弹框-->

    </z-collapse>

    <invoice-transfer v-if="applicationStatus != 108&&applicationStatus != 1006" ref="invoiceMsg" @submit="invoiceSubmit"/>
  </div>
</template>

<script>
import ZCollapse from '@/components/ZCollapse'
import invoiceTransfer from './invoiceTransfer.vue'
import mixins from '@/helper/mixins.js'
import dayjs from 'dayjs'

export default {
  name: 'ForfaitMsg',
  components: {
    ZCollapse,
    invoiceTransfer
  },
  mixins: [mixins],
  // props:['initData','comData'],
  data() {
    return {
      initData: '',

      applicationStatus: '', // 订单状态
      defaultCurrency: 'US$',
      currencyList: [], // 还款币种列表
      currency: 'US$', // 币种
      exchangeRate: '', // 汇率
      sellerAmount: '', // 卖方发票金额
      exchangeSellerAmount: '', // 卖方发票金额_转换$
      receivedPayment: '', // 定金金额
      exchangeReceivedPayment: '', // 定金_转换$
      receivedPaymentProportion: '', // 定金比例

      cicAmount: '', // cic费用
      exchangeCicAmount: '', // cic费用_转换$
      cicAmountProportion: '', // cic费用比例
      receivableAmount: '', // 还款金额
      exchangeReceivableAmount: '', // 还款金额_转换$
      receivableAmountProportion: '', // 还款金额比例
      cicLoan: '', // 贷款金额
      cicLoanZall: '', // ZALL 贷款金额
      cicLoanMizhuho: '', // Mizuho 贷款金额
      feeAmount: '', // 利息金额
      transactionDateStr: '', // 贷款发放日期
      maturityDateStr: '', // 还款日
      paymentDays: '', // 账期
      rateDiscount: '', // 利率

      estimateStartDateStr: '', // 资金出入预计开始时间
      estimateEndDateStr: '', // 资金出入预计到期时间

      zmaFundingRate: '', // zma成本率
      zallLendingRate: '', // 卓尔利率
      zallLendingMoney: '', // 卓尔利率金额
      zallLendingFinal: '', // zall实际金额
      mizhuhoLendingRate: '', // 卓红利率
      mizhuhoLendingMoney: '', // 卓红利率金额
      mizhuhoLendingFinal: '', // 卓红实际金额
      marubeniFeeRate: '', // 丸红担保费率
      marubeniFeeMoney: '', // 丸红担保费
      zmaMarginRate: '', // zma利率
      zmaProfit: '', // zma利润 // 福费廷协议 第二部分表单信息

      loanForm: '', // 福费廷提交的数据集合
      initInvoice: {}, // 发票转让初始数据
      invoiceForm: '', // 发票转让 提交的数据集合

      printVisible: false
    }
  },
  computed: {
    estimateDay() {
      return this.estimateEndDateStr && this.estimateStartDateStr && (!dayjs(this.estimateEndDateStr).isBefore(dayjs(this.estimateStartDateStr))) ? dayjs(this.estimateEndDateStr).diff(dayjs(this.estimateStartDateStr), 'day') : ''
    } // 天数
  },
  watch: {
    exchangeRate(val) {
      if (!val) {
        this.exchangeRateInput()
      }
    },
    sellerAmount(val) {
      if (!val) {
        this.sellerAmountInput()
      }
    },
    receivedPayment(val) {
      if (!val) {
        this.receivedPaymentInput()
      }
    },
    cicAmount(val) {
      if (!val) {
        this.cicAmountInput()
      }
    },
    receivableAmount(val) {
      if (!val) {
        this.receivableAmountInput()
      }
    },
    cicLoan(val) {
      if (!val) {
        this.cicLoanInput()
      }
    },
    feeAmount(val) {
      if (!val) {
        this.feeAmountInput()
      }
    },
    rateDiscount(val) {
      if (!val) {
        this.rateDiscountInput()
      }
    }, // 第一部分

    zmaFundingRate(val) {
      if (!val) {
        this.zmaFundingRateInput()
      }
    },
    zallLendingRate(val) {
      if (!val) {
        this.zallLendingRateInput()
      }
    },
    zallLendingMoney(val) {
      if (!val) {
        this.zallLendingMoneyInput()
      }
    },
    mizhuhoLendingRate(val) {
      if (!val) {
        this.mizhuhoLendingRateInput()
      }
    },
    mizhuhoLendingMoney(val) {
      if (!val) {
        this.mizhuhoLendingMoneyInput()
      }
    },
    marubeniFeeRate(val) {
      if (!val) {
        this.marubeniFeeRateInput()
      }
    }
  },
  mounted() {
  }, // 主要是为了 监听 点击清空按钮， 数据为空后没有联动清空的问题

  methods: {
    handleInit(initData, initInvoice) {
      const _this = this
      console.log(initData, '==========================')
      _this.initData = initData
      _this.initInvoice = initInvoice
      _this.initForfait()

      _this.getsSysDict().then(data => {
        const defaultData = data.transactionNotice.en
        console.log(this.initData, 'initData')
        _this.currencyList = data.moneyType.en
        _this.initInvoice.currencyList = data.moneyType.en
        _this.initInvoice.applicationStatus = _this.initData.applicationStatus
        console.log(initInvoice, 'initInvoice')
        if (_this.initInvoice.id && (_this.initData.applicationStatus != 108 && _this.initData.applicationStatus != 1006)) {
          console.log(_this.initInvoice.id, _this.initData.applicationStatus)
          this.$nextTick(() => {
            _this.$refs.invoiceMsg.handleInit(_this.initInvoice)
          })
        } else if (!_this.initData.id) {
          _this.initData = Object.assign({}, _this.initData, defaultData)
          _this.initInvoice.title = defaultData.title
          _this.initInvoice.affimBankInfo = defaultData.affimBankInfo
          _this.initInvoice.bankInfo = defaultData.bankInfo

          _this.$refs.invoiceMsg.handleInit(_this.initInvoice)
        }
      })
    }, // 设置初始值
    initForfait() {
      const _this = this
      _this.applicationStatus = _this.initData.applicationStatus
      // _this.formData.flowNumber = _this.initData.flowNumber;
      // _this.formData.seller = _this.initData.seller;
      // _this.formData.buyer = _this.initData.buyer;
      _this.currency = _this.initData.currency || 'US$'
      _this.sellerAmount = _this.initData.sellerAmount ? _this.initData.sellerAmount.toFixed(2) : ''
      _this.receivedPayment = _this.initData.receivedPayment.toFixed(2)
      _this.rateDiscount = _this.initData.rateDiscount.toFixed(3)

      _this.exchangeRate = _this.initData.exchangeRate || _this.initData.id ? _this.$utils.convertNum(_this.initData.exchangeRate, 4) : ''
      _this.exchangeSellerAmount = _this.initData.exchangeSellerAmount || _this.initData.id ? _this.initData.exchangeSellerAmount.toFixed(2) : ''
      _this.exchangeReceivedPayment = _this.initData.exchangeReceivedPayment || _this.initData.id ? _this.initData.exchangeReceivedPayment.toFixed(2) : ''

      _this.cicAmount = _this.initData.cicAmount || _this.initData.id ? _this.initData.cicAmount.toFixed(2) : ''
      _this.exchangeCicAmount = _this.initData.exchangeCicAmount || _this.initData.id ? _this.initData.exchangeCicAmount.toFixed(2) : ''
      _this.receivedPaymentProportion = _this.initData.receivedPaymentProportion || _this.initData.id ? _this.initData.receivedPaymentProportion.toFixed(3) : ''
      _this.cicAmountProportion = _this.initData.cicAmountProportion || _this.initData.id ? _this.initData.cicAmountProportion.toFixed(3) : ''
      _this.receivableAmount = _this.initData.receivableAmount || _this.initData.id ? _this.initData.receivableAmount.toFixed(2) : ''
      _this.exchangeReceivableAmount = _this.initData.exchangeReceivableAmount || _this.initData.id ? _this.initData.exchangeReceivableAmount.toFixed(2) : ''
      _this.receivableAmountProportion = _this.initData.receivableAmountProportion || _this.initData.id ? _this.initData.receivableAmountProportion.toFixed(3) : ''
      _this.cicLoanZall = _this.initData.cicLoanZall || _this.initData.id ? _this.initData.cicLoanZall.toFixed(2) : ''
      _this.cicLoanMizhuho = _this.initData.cicLoanMizhuho || _this.initData.id ? _this.initData.cicLoanMizhuho.toFixed(2) : ''
      // _this.rateDiscount = _this.initData.rateDiscount || _this.initData.id ? _this.initData.rateDiscount.toFixed(3) : '';

      _this.cicLoan = _this.initData.cicLoan ? _this.initData.cicLoan.toFixed(2) : ''
      _this.feeAmount = _this.initData.feeAmount ? _this.initData.feeAmount.toFixed(2) : ''

      _this.transactionDateStr = _this.initData.transactionDate || ''
      _this.maturityDateStr = _this.initData.maturityDate || ''

      const diff = dayjs(_this.maturityDateStr).diff(dayjs(_this.transactionDateStr), 'day')
      _this.paymentDays = diff || ''

      _this.estimateStartDateStr = _this.initData.estimateStartDate || ''
      _this.estimateEndDateStr = _this.initData.estimateEndDate || ''
      // 第一部分

      _this.mizhuhoLendingRate = _this.initData.mizhuhoLendingRate ? _this.initData.mizhuhoLendingRate.toFixed(4) : ''
      _this.marubeniFeeRate = _this.initData.marubeniFeeRate ? _this.initData.marubeniFeeRate.toFixed(4) : ''
      _this.zallLendingRate = _this.initData.zallLendingRate ? _this.initData.zallLendingRate.toFixed(4) : ''
      _this.zmaFundingRate = _this.initData.zmaFundingRate ? _this.initData.zmaFundingRate.toFixed(4) : ''
      _this.zallLendingMoney = _this.initData.zallLendingMoney ? _this.initData.zallLendingMoney.toFixed(2) : ''
      _this.zallLendingFinal = _this.initData.zallLendingFinal ? _this.initData.zallLendingFinal.toFixed(2) : ''

      _this.mizhuhoLendingMoney = _this.initData.mizhuhoLendingMoney ? _this.initData.mizhuhoLendingMoney.toFixed(2) : ''
      _this.mizhuhoLendingFinal = _this.initData.mizhuhoLendingFinal ? _this.initData.mizhuhoLendingFinal.toFixed(2) : ''

      _this.marubeniFeeMoney = _this.initData.marubeniFeeMoney ? _this.initData.marubeniFeeMoney.toFixed(2) : ''
      _this.zmaProfit = _this.initData.zmaProfit ? _this.initData.zmaProfit.toFixed(2) : ''
      _this.zmaMarginRate = _this.initData.zmaMarginRate ? _this.initData.zmaMarginRate.toFixed(4) : ''

      if (!_this.initData.id) {
        _this.$refs.invoiceMsg.exportContractAmountInput(_this.sellerAmount) // 初始化
        _this.setAssigned()
        _this.sellerAmountInput()
      }
    }, // 初始化数据

    setAssigned() {
      const _this = this
      _this.$refs.invoiceMsg.assignedInvoiceAmountInput(_this.receivedPayment, 1) // 初始化
    }, // 数据联动到 发票转让中的 Assigned Invoice Amount

    invoiceSubmit(data) {
      this.invoiceForm = data
    }, // 发票转让

    printHandle() {
      console.log('打印')
      const _this = this
      _this.printVisible = true
    },
    dialogConfirm() {
      const _this = this
      setTimeout(() => {
        _this.$print(_this.$refs.printContract)
      }, 500)
    },
    handleSubmit() {
      this.dealData()
      const checkResult = this.checkLoanForm()
      if (checkResult !== 'true') {
        const errorKey = 'forfait_' + checkResult
        this.$message.error(this.$t(`error.${errorKey}`))
        this.$emit('submit', false)
        return false
      }
      if (this.applicationStatus === 102 || this.applicationStatus === 1003) {
        this.$refs.invoiceMsg.handleSubmit()
        if (!this.invoiceForm) {
          this.$emit('submit', false)
          return false
        }
        this.loanForm = Object.assign(this.loanForm, this.invoiceForm)
      } // 只有102 才需要去获取 发票的表单信息， 108不需要
      this.loanForm.id = this.initData.id || ''
      this.loanForm.finalLoan = this.initData.finalLoan
      this.loanForm.serialNumber = this.initData.serialNumber
      console.log('大组件拿到的值', this.loanForm);
      this.$emit('submit', this.loanForm)
    }, // 确认提交 表单数据

    currencyChange() {
      this.$refs.invoiceMsg.setBaseData('currency', this.currency)
    },
    exchangeRateInput() {
      const key = 'exchangeRate'
      let val = ''
      if (this[key] > 100) {
        this[key] = '100'
      } else {
        this[key] = this.$utils.dealNumber(this[key], 4, 3)
      }
      val = this.exchangeRate
      // this[key] = this.$utils.dealNumber(this[key], 4, 3);
      this.exchangeSellerAmount = this.sellerAmount && val ? (val * this.sellerAmount).toFixed(2) : ''
      this.exchangeReceivedPayment = this.receivedPayment && val ? (this.receivedPayment * val).toFixed(2) : ''
      this.exchangeCicAmount = this.cicAmount && val ? (this.cicAmount * val).toFixed(2) : ''
      this.exchangeReceivableAmount = this.receivableAmount && val ? (this.receivableAmount * val).toFixed(2) : ''
      this.$refs.invoiceMsg.exchangeRateInput(this[key])
    }, // 监听 汇率

    sellerAmountInput: function() {
      // console.log('sellerAmount ===='+this.sellerAmount);
      // console.log(this.sellerAmount);
      this.moneyInput('sellerAmount')
      const val = this.sellerAmount
      this.exchangeSellerAmount = val && this.exchangeRate ? (val * this.exchangeRate).toFixed(2) : ''
      this.receivedPaymentProportion = val ? (this.receivedPayment * 100 / val).toFixed(3) : ''
      this.cicAmountProportion = val ? (this.cicAmount * 100 / val).toFixed(3) : ''
      this.receivableAmountProportion = val ? (this.receivableAmount * 100 / val).toFixed(3) : ''
      this.calcCicAmount()// cic费用

      this.$nextTick(() => {
        this.$refs.invoiceMsg.exportContractAmountInput(val)
      })
    }, // 监听 卖方发票金额
    invoiceNumberCoftInput() {
      this.$nextTick(() => {
        this.$refs.invoiceMsg.invoiceNumberCoftInput(this.initData.invoiceNumberCoft)
      })
    },
    receivedPaymentInput: function() {
      this.moneyInput('receivedPayment')
      const val = this.receivedPayment
      this.exchangeReceivedPayment = val && this.exchangeRate ? (val * this.exchangeRate).toFixed(2) : ''
      this.receivedPaymentProportion = this.sellerAmount ? (val * 100 / this.sellerAmount).toFixed(3) : ''
      this.calcCicAmount()
      this.setAssigned()
    }, // 监听 定金
    cicAmountInput: function(type) {
      if (type !== 1) {
        this.moneyInput('cicAmount')
      } // 计算结果可能为负数，需要正常展示， 不能做处理
      const val = this.cicAmount
      this.exchangeCicAmount = val && this.exchangeRate ? (val * this.exchangeRate).toFixed(2) : ''
      this.cicAmountProportion = this.sellerAmount ? (val * 100 / this.sellerAmount).toFixed(3) : ''
      this.$refs.invoiceMsg.collectionAgentFeeInput(-this.cicAmount)
    }, // 监听 CIC费用
    receivableAmountInput: function(type) {
      if (type !== 1) {
        this.moneyInput('receivableAmount')
      }
      const val = this.receivableAmount
      this.exchangeReceivableAmount = val && this.exchangeRate ? (val * this.exchangeRate).toFixed(2) : ''
      this.receivableAmountProportion = this.sellerAmount ? (val * 100 / this.sellerAmount).toFixed(3) : ''
      this.calcCicAmount()
      this.$refs.invoiceMsg.cicPayAmountInput(this.receivableAmount)
    }, // 监听 还款金额

    cicLoanInput: function() {
      this.moneyInput('cicLoan')
      const val = this.cicLoan
      this.cicLoanZall = (val * 0.51).toFixed(2)
      this.cicLoanMizhuho = (val * 0.49).toFixed(2)
      this.calcFeeAmount()// 利息金额
      this.calcReceivableAmount()// 还款
      this.$refs.invoiceMsg.zmaPurchaseAmountInput(this.cicLoan)
    }, // 监听 贷款金额

    feeAmountInput: function() {
      this.moneyInput('feeAmount')
      this.calcReceivableAmount()// 计算还款金额
    }, // 监听 利息金额

    rateDiscountInput: function() {
      this.rateInput('rateDiscount')
      this.calcFeeAmount()
    }, // 监听 利率

    transactionDateStrChange: function() {
      const val = this.transactionDateStr
      const diff = this.maturityDateStr && val ? dayjs(this.maturityDateStr).diff(dayjs(val), 'day') : ''
      this.paymentDays = dayjs(this.maturityDateStr).isBefore(dayjs(val)) ? '' : diff
      this.calcFeeAmount()
      this.$refs.invoiceMsg.setBaseData('transactionDate', this.transactionDateStr)
    }, // 监听 贷款发放日期

    maturityDateStrChange: function() {
      const val = this.maturityDateStr
      const diff = this.transactionDateStr && val ? dayjs(val).diff(dayjs(this.transactionDateStr), 'day') : ''
      this.paymentDays = dayjs(val).isBefore(dayjs(this.transactionDateStr)) ? '' : diff
      this.calcFeeAmount()
      this.$refs.invoiceMsg.setBaseData('cicPayDate', this.maturityDateStr)
    }, // 监听 还款日

    calcFeeAmount: function() {
      this.feeAmount = this.rateDiscount && this.cicLoan && this.paymentDays ? (this.rateDiscount * this.paymentDays * this.cicLoan / 100 / 360).toFixed(2) : ''
      // 利息金额=利率*账期&贷款金额/100/360
      this.calcReceivableAmount()// 计算还款金额
    }, // 计算利息金额
    calcCicAmount: function() {
      this.cicAmount = (this.sellerAmount - this.receivedPayment - this.receivableAmount).toFixed(2) // cic费用=卖方发票金额-定金-还款金额
      this.cicAmountInput(1)
    }, // 计算cic费用
    calcReceivableAmount: function() {
      this.receivableAmount = (Number(this.cicLoan) + Number(this.feeAmount)).toFixed(2) // 还款 = 贷款 + 利息
      this.receivableAmountInput()
    }, // 计算还款金额
    // 第一部分

    zmaFundingRateInput: function() {
      this.rateInput('zmaFundingRate')
      const val = this.zmaFundingRate
      this.zmaMarginRate = (this.rateDiscount - val).toFixed(4)
      this.zmaProfit = (this.cicLoan * (this.rateDiscount - val) * this.paymentDays / 36000).toFixed(2)
    }, // 监听 zma成本率
    zallLendingRateInput: function() {
      this.rateInput('zallLendingRate')
      const val = this.zallLendingRate
      this.zmaFundingRate = val// ZMA成本 = 卓尔利率
      this.zallLendingMoney = val ? (this.cicLoan * val * this.paymentDays / 36000 * 0.51).toFixed(2) : ''
      this.zmaFundingRateInput()
      this.zallLendingMoneyInput()
    }, // 监听 卓尔利率
    zallLendingMoneyInput: function() {
      this.moneyInput('zallLendingMoney')
      const val = this.zallLendingMoney
      this.zallLendingFinal = (Number(this.cicLoanZall) + Number(val)).toFixed(2)
    }, // 监听 卓尔利率金额
    mizhuhoLendingRateInput: function() {
      this.rateInput('mizhuhoLendingRate')
      const val = this.mizhuhoLendingRate
      this.zallLendingRate = (Number(val) + Number(this.marubeniFeeRate)).toFixed(4)
      // this.zallLendingRate = Number(val) + Number(this.marubeniFeeRate);
      // this.rateInput('zallLendingRate',4)
      this.mizhuhoLendingMoney = val ? (this.cicLoan * val * this.paymentDays / 36000 * 0.49).toFixed(2) : ''
      this.zallLendingRateInput()
      this.mizhuhoLendingMoneyInput()
    }, // 监听 卓红Mizuho 利率
    mizhuhoLendingMoneyInput: function() {
      this.moneyInput('mizhuhoLendingMoney')
      const val = this.mizhuhoLendingMoney
      this.mizhuhoLendingFinal = (Number(this.cicLoanMizhuho) + Number(val)).toFixed(2)
    }, // 监听 卓红Mizuho 利率金额
    marubeniFeeRateInput: function() {
      this.rateInput('marubeniFeeRate')
      const val = this.marubeniFeeRate
      this.zallLendingRate = (Number(val) + Number(this.mizhuhoLendingRate)).toFixed(4)
      this.marubeniFeeMoney = val ? (this.cicLoan * val * this.paymentDays / 36000 * 0.49).toFixed(2) : ''
      // console.log(this.marubeniFeeMoney);
      this.zallLendingRateInput()
    }, // 监听 丸红担保费 率

    dealData() {
      const _this = this
      _this.loanForm = {}
      if (_this.applicationStatus === 102 || _this.applicationStatus === 1003) {
        _this.loanForm.currency = _this.currency
        _this.loanForm.exchangeRate = _this.exchangeRate
        _this.loanForm.sellerAmount = _this.sellerAmount
        _this.loanForm.exchangeSellerAmount = _this.exchangeSellerAmount
        _this.loanForm.receivedPayment = _this.receivedPayment
        _this.loanForm.exchangeReceivedPayment = _this.exchangeReceivedPayment
        _this.loanForm.receivedPaymentProportion = _this.receivedPaymentProportion
        _this.loanForm.cicAmount = _this.cicAmount
        _this.loanForm.exchangeCicAmount = _this.exchangeCicAmount
        _this.loanForm.cicAmountProportion = _this.cicAmountProportion
        _this.loanForm.receivableAmount = _this.receivableAmount
        _this.loanForm.exchangeReceivableAmount = _this.exchangeReceivableAmount
        _this.loanForm.receivableAmountProportion = _this.receivableAmountProportion
        _this.loanForm.cicLoan = _this.cicLoan
        _this.loanForm.cicLoanZall = _this.cicLoanZall
        _this.loanForm.cicLoanMizhuho = _this.cicLoanMizhuho
        _this.loanForm.feeAmount = _this.feeAmount
        this.loanForm.invoiceNumberCoft = this.initData.invoiceNumberCoft
        _this.loanForm.transactionDateStr = _this.transactionDateStr ? dayjs(_this.transactionDateStr).format('YYYY-MM-DD') : ''
        _this.loanForm.maturityDateStr = _this.maturityDateStr ? dayjs(_this.maturityDateStr).format('YYYY-MM-DD') : ''
        _this.loanForm.paymentDays = _this.paymentDays // 账期

        _this.loanForm.rateDiscount = _this.rateDiscount
        _this.loanForm = Object.assign(_this.loanForm, _this.formData)

        if (!_this.initData.finalLoan) {
          _this.loanForm.estimateStartDateStr = _this.estimateStartDateStr ? dayjs(_this.estimateStartDateStr).format('YYYY-MM-DD') : ''
          _this.loanForm.estimateEndDateStr = _this.estimateEndDateStr ? dayjs(_this.estimateEndDateStr).format('YYYY-MM-DD') : ''
          _this.loanForm.estimateDay = _this.estimateDay
        } // 如果是最终放款 不需要填写 预计日期及账期

        _this.loanForm.collectionBank = _this.initData.collectionBank // 收款银行名称
        _this.loanForm.collectionBankSwifucode = _this.initData.collectionBankSwifucode // 收款银行swiftcode
        _this.loanForm.middleBank = _this.initData.middleBank // 中间行名称
        _this.loanForm.middleSwifucode = _this.initData.middleSwifucode // 中间行swiftcode
        _this.loanForm.accountNumber = _this.initData.accountNumber // 账号
        _this.loanForm.remarks = _this.initData.remarks
      } else if (_this.applicationStatus === 108 || _this.applicationStatus === 1006) {
        _this.loanForm.id = _this.initData.id
        _this.loanForm.zmaFundingRate = _this.zmaFundingRate
        _this.loanForm.zallLendingRate = _this.zallLendingRate
        _this.loanForm.zallLendingMoney = _this.zallLendingMoney
        _this.loanForm.zallLendingFinal = _this.zallLendingFinal
        _this.loanForm.mizhuhoLendingRate = _this.mizhuhoLendingRate
        _this.loanForm.mizhuhoLendingMoney = _this.mizhuhoLendingMoney
        _this.loanForm.mizhuhoLendingFinal = _this.mizhuhoLendingFinal
        _this.loanForm.marubeniFeeRate = _this.marubeniFeeRate
        _this.loanForm.marubeniFeeMoney = _this.marubeniFeeMoney
        _this.loanForm.zmaMarginRate = _this.zmaMarginRate
        _this.loanForm.zmaProfit = _this.zmaProfit
      }

      // console.log(_this.loanForm);
    }, // 整合数据

    checkLoanForm() {
      const _this = this
      const result = _this._.findKey(_this.loanForm, (val, key) => {
        // console.log(key+':'+val);
        if ((!val && key !== 'remarks' && key != 'invoiceNumberCoft') || (!val && key == 'invoiceNumberCoft' && !_this.initData.invoiceNumber)) {
          // if(_this.initData.finalLoan && (key === 'forfait_estimateStartDateStr' || key==='forfait_estimateEndDateStr'))
          // console.log(key, val, _this.loanForm.invoiceNumber)
          return key
        }
      })

      if (!result && (_this.applicationStatus === 102 || _this.applicationStatus === 1003)) {
        if (_this.loanForm.cicAmount < 0) {
          return 'cicAmount_1'
        }// 还款金额不能为负数
        if (_this.loanForm.receivableAmount < 0) {
          return 'receivableAmount_1'
        }// 还款金额不能为负数
        if (_this.loanForm.feeAmount < 0) {
          return 'feeAmount_1'
        }// 利息金额不能为负数
      }

      if (!result && (_this.applicationStatus === 108 || _this.applicationStatus === 1006)) {
        if (_this.loanForm.zmaMarginRate < 0) {
          return 'zmaMarginRate_1'
        }// ZMA利率利润不能为负数
        if (_this.loanForm.zmaProfit < 0) {
          return 'zmaProfit_1'
        }// ZMA利润不能为负数
      }

      // console.log(result);
      return result || 'true'
    }, // 校验 表单

    moneyInput(key) {
      this[key] = this.$utils.dealNumber(this[key], 2, 12)
    },
    rateInput(key) {
      if (this[key] > 100) {
        this[key] = '100'
        return false
      }
      this[key] = this.$utils.dealNumber(this[key], 4, 3)
    },

    numberBlur(key, num) {
      this[key] = this.$utils.convertNum(this[key], num)
    } // 失去焦点 格式化数值

  }
}
</script>

<style lang="scss">
  .forfait-msg {
    .forfait {
      padding-bottom: 10px;
    }

    .print-msg {
      width: auto;
      display: none;

      .m-tit h3 {
        text-align: left;
      }
    }

    .loan-msg {
      border-top: 1px solid #EEEEEE;
    }

    .c-list.edit {
      .firstEdit {
        .el-input__inner {
          border-color: #7996f5;
        }
      }
    }

  }

  .dialogPrint {
    margin: 0 !important;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding-top: 0;
    }

    .print-footer {
      .centerBtn {
        margin: 0 10px;
      }
    }

    .print-msg {
      margin: 0 auto;
    }
  }
</style>
